import { createSlice } from '@reduxjs/toolkit';
import addUpsellPriceReducer from 'src/store/upsell/reducer/addUpsellPriceReducer';
import clearUpsellPriceReducer from 'src/store/upsell/reducer/clearUpsellPriceReducer';
import updateUpsellTotalPriceReducer from 'src/store/upsell/reducer/updateUpsellTotalPriceReducer';
import setUpsellPriceDataReducer from 'src/store/upsell/reducer/setUpsellPriceDataReducer';
import setFrameUpsellDataReducer from 'src/store/upsell/reducer/setFrameUpsellDataReducer';

import { UpsellState } from 'src/store/upsell/types';
import setFrameUpsellSelectedFrameReducer from './reducer/setFrameUpsellSelectedFrameReducer';
import setBeforeAddToBasketUpsellWasShownReducer from './reducer/setBeforeAddToBasketUpsellWasShownReducer';
import displayUpsellBeforeAddToBasketReducer from './reducer/displayUpsellBeforeAddToBasketReducer';

export const upsellInitialState: UpsellState = {
  upsellPrice: {},
  upsellTotalPrice: {
    price: 0,
    priceInitial: 0,
  },
  upsellPriceData: {},
  frameUpsellPopupData: undefined,
  frameUpsellSelectedFrame: undefined,
  displayUpsellBeforeAddToBasket: false,
  isBeforeAddToBasketUpsellWasShown: false,
};

export const slice = createSlice({
  name: 'upsell',
  initialState: upsellInitialState,
  reducers: {
    setUpsellPriceDataAction: setUpsellPriceDataReducer,
    addUpsellPriceAction: addUpsellPriceReducer,
    updateUpsellTotalPriceAction: updateUpsellTotalPriceReducer,
    clearUpsellPriceAction: clearUpsellPriceReducer,
    setFrameUpsellDataAction: setFrameUpsellDataReducer,
    setFrameUpsellSelectedFrameAction: setFrameUpsellSelectedFrameReducer,
    displayUpsellBeforeAddToBasketAction: displayUpsellBeforeAddToBasketReducer,
    setBeforeAddToBasketUpsellWasShownAction: setBeforeAddToBasketUpsellWasShownReducer,
  },
});

export const {
  addUpsellPriceAction,
  updateUpsellTotalPriceAction,
  clearUpsellPriceAction,
  setUpsellPriceDataAction,
  setFrameUpsellDataAction,
  setFrameUpsellSelectedFrameAction,
  displayUpsellBeforeAddToBasketAction,
  setBeforeAddToBasketUpsellWasShownAction,
} = slice.actions;

const addone = slice.reducer;
export default addone;
